import type { HelpFile } from '../../types/help'
import { TypeDetailTestIds } from '../../../testids/TypeDetailTestIds'

export const typeDetailHelp: HelpFile = {
  docPage: '/docs/admin/types',
  texts: {
    [TypeDetailTestIds.typeDetailPage]: 'Detailansicht eines Aufzählungstyps — seine Werte, Übersetzungen und die Entitäten, die ihn verwenden.',
    [TypeDetailTestIds.btnAddValue]: 'Einen neuen Wert zu diesem Typ hinzufügen. Werte können nach Verwendung nicht gelöscht werden — setze sie stattdessen inaktiv.',
    [TypeDetailTestIds.btnSetInactive]: 'Diesen Typwert als inaktiv markieren. Bestehende Referenzen bleiben erhalten, aber der Wert erscheint nicht mehr in neuen Auswahllisten.',
    [TypeDetailTestIds.btnCloseView]: 'Diese Detailansicht schließen und zur Typliste zurückkehren.',
    [TypeDetailTestIds.btnCancelDelete]: null,
    [TypeDetailTestIds.btnConfirmDelete]: null,
    [TypeDetailTestIds.btnEditTranslations]: null,
  },
}
